import { KYMW5300Model } from '../kymw5300.model';
import { KYMW5300commonModel } from '../vo/kymw5300-common.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * カテゴリマスタ取得
 */
@Injectable()
export class GetCategoryInfoService extends PlessJsonResponderSub<any> {

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /** 処理に使用するModel */
  private model: KYMW5300Model;
  private successFunc: Function;
  private kymw5300commonVO: KYMW5300commonModel;

  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.kymw5300commonVO.orderCode,
        StockLimitFlg: this.kymw5300commonVO.stockLimitFlg,
      }
    })
  }

  /** APIを呼ぶ */
  execute(model: KYMW5300Model, kymw5300commonVO: KYMW5300commonModel, successFunc: Function): void {
    this.model = model;
    this.kymw5300commonVO = kymw5300commonVO;
    this.successFunc = successFunc;
    this.send('getCategoryInfo', this.getBody());
  }

  /** API通信成功時の処理(PlessResponderのメソッドをオーバーライド) */
  success(data: any) {
    if (this.successFunc !== null) {
      this.successFunc();
    }
    if (data !== null) {
      this.model.getCategory(data);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetUserClientNameService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }

}
